import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const CustomerFilter = () => {
  return (
    <section className="py-12 md:py-16 bg-gradient-to-r from-blue-700 to-blue-600">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Servizio dedicato a chi vuole risolvere subito
          </h3>
          
          <div className="space-y-3">
            <div className="flex items-center justify-center gap-3">
              <CheckCircle2 className="h-6 w-6 flex-shrink-0" />
              <p className="text-lg">Diamo priorità a clienti pronti a iniziare</p>
            </div>
            <div className="flex items-center justify-center gap-3">
              <CheckCircle2 className="h-6 w-6 flex-shrink-0" />
              <p className="text-lg">Interventi a partire da 60€</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerFilter;
